export const SET_STRAINS		= "SET_STRAINS";
export const SET_FORMS			= "SET_FORMS";
export const SET_MEASURES		= "SET_MEASURES";
export const SET_CULTIVARS		= "SET_CULTIVARS";

export const actionSetStrains	= strains => ({ type: SET_STRAINS, strains:strains });
export const actionSetForms		= forms => ({ type: SET_FORMS, forms:forms });
export const actionSetMeasures	= measures => ({ type: SET_MEASURES, measures:measures });
export const actionSetCultivars	= cultivars => ({ type: SET_CULTIVARS, cultivars:cultivars });
